const sims = [
  // {
  //   _id: 88,
  //   title: 'Template',
  //   description:
  //     'This is a template simulation. You can use it to create your own simulation.',
  // },
  {
    _id: 1,
    title: 'Value Chain',
    description:
      'Fine-tune your value chain to quickly turn a company around. ',
  },
  {
    _id: 2,
    title: 'Startup Funding',
    description:
      'Highlight the benefits and drawbacks of how you fund your startup.',
  },
  // {
  //   _id: 3,
  //   title: 'Marketing Plan Consultant',
  //   description:
  //     "Optimize your client's marketing plan to keep their business.",
  // },
  // {
  //   _id: 4,
  //   title: 'Supply & Demand',
  //   description: 'Use supply and demand to determine the price of a product.',
  // },
  {
    _id: 6,
    // title: 'Business Consultant',
    // description: 'Use your business acumen to help a company grow and thrive.',
    title: 'Consultor de Gestión (Marketing)',
    description:
      'Utiliza tu conocimiento para ayudar a una empresa a crecer y prosperar.',
  },
  // {
  //   _id: 7,
  //   // title: 'Business Consultant',
  //   // description: 'Use your business acumen to help a company grow and thrive.',
  //   title: 'Quizzer',
  //   description: 'Sample quiz and feedback simulation to test your knowledge.',
  // },
  {
    _id: 8,
    // title: 'Business Consultant',
    // description: 'Use your business acumen to help a company grow and thrive.',
    title: 'Entendiendo al Consumidor',
    description: 'Entender al consumidor y mejorar la experiencia del cliente.',
  },
  {
    _id: 9,
    // title: 'Business Consultant',
    // description: 'Use your business acumen to help a company grow and thrive.',
    title: 'Entendiendo la Estrategia',
    description:
      'Entender la estrategia empresarial y mejorar la toma de decisiones.',
  },
];

export default sims;
